import script from "./ProgramsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramsView.vue?vue&type=script&setup=true&lang=js"

import "./ProgramsView.vue?vue&type=style&index=0&id=d22f4810&lang=scss&scoped=true"
import "./ProgramsView.vue?vue&type=style&index=1&id=d22f4810&lang=css"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d22f4810"]])

export default __exports__